import axios from 'axios'
// import router from './../../../router'

export const getJenseks = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-jenseks")
            .then((response) => {
                commit('SET_JENSEKS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeJensek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-jensek", payload).then((response) => {
            dispatch("getJenseks").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateJensek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-jensek/" + payload.id, payload).then((response) => {
            dispatch("getJenseks").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteJensek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-jensek/" + payload.id).then((response) => {
            dispatch("getJenseks").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data admin!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

//////////////////////////////////////////////////////////

export const getJegurs = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-jegurs/" + payload)
            .then((response) => {
                commit('SET_JEGURS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const getJegursAll = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-jegurs-all")
            .then((response) => {
                commit('SET_JEGURS_ALL', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeJegur = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.jenis_guru;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-jegur", payload).then((response) => {
            dispatch("getJegurs", payload.jenseks_id).then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateJegur = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.jenis_guru;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-jegur/" + payload.id, payload).then((response) => {
            dispatch("getJegurs", payload.jenseks_id).then(() => {
                dispatch("getMapels", payload.jenseks_id).then(() => {
                    let notif = {
                        msg: nama + " Berhasil diupdate~",
                        type: "update"
                    }
                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok")
                });

            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteJegur = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.jenis_guru;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-jegur/" + payload.id).then((response) => {
            dispatch("getJegurs", payload.jenseks_id).then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru atau data mapel!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

////////////////////////////////////////////////jendik

export const getJendiks = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-jendiks")
            .then((response) => {
                commit('SET_JENDIKS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeJendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.jenis_tendik;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-jendik", payload).then((response) => {
            dispatch("getJendiks").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateJendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.jenis_tendik;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-jendik/" + payload.id, payload).then((response) => {
            dispatch("getJendiks").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteJendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.jenis_guru;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-jendik/" + payload.id).then((response) => {
            dispatch("getJendiks").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data tendik!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

////////////////endjendik

export const getMapels = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-mapels/" + payload)
            .then((response) => {
                commit('SET_MAPELS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeMapel = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-mapel", payload).then((response) => {
            dispatch("getMapels", payload.jenseks_id).then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateMapel = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-mapel/" + payload.id, payload).then((response) => {
            dispatch("getMapels", payload.jenseks_id).then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteMapel = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-mapel/" + payload.id).then((response) => {
            dispatch("getMapels", payload.jenseks_id).then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data rombongan belajar!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}


export const getKecams = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-kecams")
            .then((response) => {
                commit('SET_KECAMS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeKecam = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-kecam", payload).then((response) => {
            dispatch("getKecams").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateKecam = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-kecam/" + payload.id, payload).then((response) => {
            dispatch("getKecams").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteKecam = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-kecam/" + payload.id).then((response) => {
            dispatch("getKecams").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.exist) {
                let existNotif = "*Data telah memiliki data kelurahan!";
                commit("SET_SQL", existNotif, { root: true });
            }
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const getKelurs = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-kelurs")
            .then((response) => {
                commit('SET_KELURS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeKelur = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-kelur", payload).then((response) => {
            dispatch("getKelurs").then(() => {
                dispatch("getKecams").then(() => {
                    let notif = {
                        msg: nama + " Berhasil ditambahkan~",
                        type: "create"
                    }
                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok")
                });
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateKelur = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-kelur/" + payload.id, payload).then((response) => {
            dispatch("getKelurs").then(() => {
                dispatch("getKecams").then(() => {
                    let notif = {
                        msg: nama + " Berhasil diupdate~",
                        type: "update"
                    }

                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok")
                });
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteKelur = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-kelur/" + payload.id).then((response) => {
            dispatch("getKelurs").then(() => {
                dispatch("getKecams").then(() => {
                    let notif = {
                        msg: nama + " Berhasil dihapus~",
                        type: "delete"
                    }

                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok")
                });
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data sekolah!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

//////////////////////////////// Paone
export const getPaones = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-paones")
            .then((response) => {
                commit('SET_PAONES', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storePaone = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_gol;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-paone", payload).then((response) => {
            dispatch("getPaones").then(() => {
                let notif = {
                    msg: nama + ", " + payload.gol + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updatePaone = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_gol;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-paone/" + payload.id, payload).then((response) => {
            dispatch("getPaones").then(() => {
                let notif = {
                    msg: nama + ", " + payload.gol + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deletePaone = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_gol;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-paone/" + payload.id).then((response) => {
            dispatch("getPaones").then(() => {
                let notif = {
                    msg: nama + ", " + payload.gol + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

///////////////////////////// Patwo

export const getPatwos = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-patwos")
            .then((response) => {
                commit('SET_PATWOS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storePatwo = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_gol;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-patwo", payload).then((response) => {
            dispatch("getPatwos").then(() => {
                let notif = {
                    msg: nama + ", " + payload.gol + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updatePatwo = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_gol;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-patwo/" + payload.id, payload).then((response) => {
            dispatch("getPatwos").then(() => {
                let notif = {
                    msg: nama + ", " + payload.gol + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deletePatwo = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_gol;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-patwo/" + payload.id).then((response) => {
            dispatch("getPatwos").then(() => {
                let notif = {
                    msg: nama + ", " + payload.gol + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data tendik!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

////////////////////////////////////////////////

export const getTajars = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tajars")
            .then((response) => {
                commit('SET_TAJARS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const getTajarAktif = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tajar-aktif")
            .then((response) => {
                commit('SET_TAJAR_AKTIF', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const getTajarsNonAktif = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tajars-non-aktif")
            .then((response) => {
                commit('SET_TAJARS_NON_AKTIF', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeTajar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tahun_ajaran;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-tajar", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getTajars").then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateTajar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tahun_ajaran;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-tajar/" + payload.id, payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }
            dispatch("getTajars").then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteTajar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tahun_ajaran;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-tajar/" + payload.id).then((response) => {
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getTajars").then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data rombongan belajar/kalender pendidikan!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const aktifkanTajar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tahun_ajaran;
    return new Promise((resolve, reject) => {
        axios.put("/api/aktifkan-tajar/" + payload.id).then((response) => {
            let notif = {
                msg: nama + " Berhasil diaktifkan~",
                type: "update"
            }
            dispatch("getTajars").then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

///////////////////////////// Education

export const getEdus = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-edus")
            .then((response) => {
                commit('SET_EDUS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeEdu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-edu", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getEdus").then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateEdu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-edu/" + payload.id, payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }
            dispatch("getEdus").then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteEdu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-edu/" + payload.id).then((response) => {
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getEdus").then(() => {
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

//////////////////tutam
export const getTutams = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tutams")
            .then((response) => {
                commit('SET_TUTAMS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeTutam = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tugas_tambahan;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-tutam", payload).then((response) => {
            dispatch("getTutams").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateTutam = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tugas_tambahan;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-tutam/" + payload.id, payload).then((response) => {
            dispatch("getTutams").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteTutam = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tugas_tambahan;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-tutam/" + payload.id).then((response) => {
            dispatch("getTutams").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

/////////////////////// alar
export const getAlars = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-alars")
            .then((response) => {
                commit('SET_ALARS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeAlar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.alasan;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-alar", payload).then((response) => {
            dispatch("getAlars").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateAlar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.alasan;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-alar/" + payload.id, payload).then((response) => {
            dispatch("getAlars").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteAlar = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.alasan;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-alar/" + payload.id).then((response) => {
            dispatch("getAlars").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

/////////////////////// agama
export const getAgamas = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-agamas")
            .then((response) => {
                commit('SET_AGAMAS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeAgama = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-agama", payload).then((response) => {
            dispatch("getAgamas").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateAgama = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-agama/" + payload.id, payload).then((response) => {
            dispatch("getAgamas").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteAgama = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-agama/" + payload.id).then((response) => {
            dispatch("getAgamas").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

/////////////////////// stapeg
export const getStapegs = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-stapegs")
            .then((response) => {
                commit('SET_STAPEGS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeStapeg = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-stapeg", payload).then((response) => {
            dispatch("getStapegs").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateStapeg = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-stapeg/" + payload.id, payload).then((response) => {
            dispatch("getStapegs").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteStapeg = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-stapeg/" + payload.id).then((response) => {
            dispatch("getStapegs").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data guru!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}


/////////////////////// berkas
export const getBerkas = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-berkas")
            .then((response) => {
                commit('SET_BERKAS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-berkas", payload).then((response) => {
            dispatch("getBerkas").then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-berkas/" + payload.id, payload).then((response) => {
            dispatch("getBerkas").then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-berkas/" + payload.id).then((response) => {
            dispatch("getBerkas").then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data PTK!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}


export const getKontak = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-kontak/" + payload)
            .then((response) => {
                commit('SET_KONTAK', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}